import { defineStore } from 'pinia';
// eslint-disable-next-line import/no-extraneous-dependencies
import { notify } from 'notiwind';

import {
  Get,
} from '@/api/productCategories';

// eslint-disable-next-line import/prefer-default-export
export const useProductCategoriesStore = defineStore('productCategories', {
  state: () => ({
    data: [],
    isLoading: false,
  }),
  actions: {
    async Load() {
      this.isLoading = true;
      try {
        const { data: { data } } = await Get();
        this.data = data;
      } catch (error) {
        let message;
        if (error.response) {
          message = error.response.data.message;
        }
        message = message ?? 'An error occured while loading product categories';
        notify(
          {
            variant: 'bg-red-700',
            group: 'foo',
            text: message,
          },
          5000,
        );
      } finally {
        this.isLoading = false;
      }
    },
  },
  getters: {
    Data: (state) => state.data,
    IsLoading: (state) => state.isLoading,
  },
});
